﻿/**
 * re_countries_data
 * @module countriesData
 * @author Matt Foulger
 */

define(['pubsub','generalUtilities'],

	function countriesData(pubsub, generalUtilities) {
		'use strict';

		var data = [
			{
				"id": 2,
				"resourceName": "Regions.AFGHANISTAN",
				// AFN
				"defaultCurrencyId": "35074CC8-62D7-43DA-A2E8-9FD1A870B1BB"
			},
			{
				"id": 5,
				"resourceName": "Regions.ALBANIA",
				// ALL
				"defaultCurrencyId": "AF3867B1-C808-447E-9874-C0E55C08EE98"
			},
			{
				"id": 61,
				"resourceName": "Regions.ALGERIA",
				// DZD
				"defaultCurrencyId": "B18CD23C-AE01-443C-9994-94F685460D0A"
			},
			{
				"id": 11,
				"resourceName": "Regions.AMERICAN_SAMOA",
				"defaultCurrencyId": ""
			},
			{
				"id": 6,
				"resourceName": "Regions.ANDORRA",
				// EUR
				"defaultCurrencyId": "1EF1CBF0-57C4-11E3-AB91-CB986188709B"
			},
			{
				"id": 3,
				"resourceName": "Regions.ANGOLA",
				// AOA
				"defaultCurrencyId": "041D0DBC-84F0-48CB-8B66-DDC7A9CC4B70"
			},
			{
				"id": 4,
				"resourceName": "Regions.ANGUILLA",
				// XCD
				"defaultCurrencyId": "8E93696F-889D-4147-89DA-F865D668ABD9"
			},
			{
				"id": 12,
				"resourceName": "Regions.ANTARCTICA",
				"defaultCurrencyId": ""
			},
			{
				"id": 14,
				"resourceName": "Regions.ANTIGUA_AND_BARBUDA",
				// XCD
				"defaultCurrencyId": "8E93696F-889D-4147-89DA-F865D668ABD9"
			},
			{
				"id": 9,
				"resourceName": "Regions.ARGENTINA",
				// ARS
				"defaultCurrencyId": "23BE598C-57C4-11E3-AB55-D1986188709B"
			},
			{
				"id": 10,
				"resourceName": "Regions.ARMENIA",
				// AMD
				"defaultCurrencyId": "4FBC4820-360C-44AA-9932-6ADB9A741355"
			},
			{
				"id": 1,
				"resourceName": "Regions.ARUBA",
				// AWG
				"defaultCurrencyId": "5184F064-5036-4A26-A258-A1C0F21E9C76"
			},
			{
				"id": 15,
				"resourceName": "Regions.AUSTRALIA",
				//AUD
				"defaultCurrencyId": "271c7dd4-57c4-11e3-a267-d2986188709b"
			},
			{
				"id": 16,
				"resourceName": "Regions.AUSTRIA",
				//EUR
				"defaultCurrencyId": "1ef1cbf0-57c4-11e3-ab91-cb986188709b"
			},
			{
				"id": 17,
				"resourceName": "Regions.AZERBAIJAN",
				// AZN
				"defaultCurrencyId": "28CF282A-57C4-11E3-9BDA-D3986188709B"
			},
			{
				"id": 25,
				"resourceName": "Regions.BAHAMAS",
				// BSD
				"defaultCurrencyId": "D17C76E6-4270-41F6-8A9E-4B59CE73E57F"
			},
			{
				"id": 24,
				"resourceName": "Regions.BAHRAIN",
				// BHD
				"defaultCurrencyId": "AAA4B5E2-FB6A-4149-8EFB-9E270A1B06A4"
			},
			{
				"id": 22,
				"resourceName": "Regions.BANGLADESH",
				// BDT
				"defaultCurrencyId": "D1024A9D-DEBC-4AFE-82F0-4893B3235375"
			},
			{
				"id": 32,
				"resourceName": "Regions.BARBADOS",
				// BBD
				"defaultCurrencyId": "963D229F-4B31-4D46-A371-B14D3B26264C"
			},
			{
				"id": 27,
				"resourceName": "Regions.BELARUS",
				// BYN
				"defaultCurrencyId": "DC987AAD-F165-41C5-8365-D5A6A0F63218"
			},
			{
				"id": 19,
				"resourceName": "Regions.BELGIUM",
				//EUR
				"defaultCurrencyId": "1ef1cbf0-57c4-11e3-ab91-cb986188709b"
			},
			{
				"id": 28,
				"resourceName": "Regions.BELIZE",
				// BZD
				"defaultCurrencyId": "5BBED400-B548-48F9-9DC0-8AA4075DED9E"
			},
			{
				"id": 20,
				"resourceName": "Regions.BENIN",
				// XOF
				"defaultCurrencyId": "1AFB48F1-485B-47AB-A67C-9DF4A9D08216"
			},
			{
				"id": 29,
				"resourceName": "Regions.BERMUDA",
				// BMD
				"defaultCurrencyId": "7E08E2B6-EB42-478A-9DC3-FE2DE8042977"
			},
			{
				"id": 34,
				"resourceName": "Regions.BHUTAN",
				// INR
				"defaultCurrencyId": "45575F9E-57C4-11E3-99F3-0A996188709B"
			},
			{
				"id": 30,
				"resourceName": "Regions.BOLIVIA",
				// BOB
				"defaultCurrencyId": "09A78170-9552-46A1-B0CB-3BA349E0E9BC"
			},
			{
				"id": 26,
				"resourceName": "Regions.BOSNIA_AND_HERZEGOWINA",
				// BAM
				"defaultCurrencyId": "2B0418B2-57C4-11E3-8746-D4986188709B"
			},
			{
				"id": 36,
				"resourceName": "Regions.BOTSWANA",
				// BWP
				"defaultCurrencyId": "2EC8702E-57C4-11E3-8DC1-D6986188709B"
			},
			{
				"id": 35,
				"resourceName": "Regions.BOUVET_ISLAND",
				"defaultCurrencyId": ""
			},
			{
				"id": 31,
				"resourceName": "Regions.BRAZIL",
				//BRL
				"defaultCurrencyId": "2d310af0-57c4-11e3-a123-d5986188709b"
			},
			{
				"id": 101,
				"resourceName": "Regions.BRITISH_INDIAN_OCEAN_TERRITORY",
				// USD
				"defaultCurrencyId": "1994DD50-57C4-11E3-9C0D-BD986188709B"
			},
			{
				"id": 33,
				"resourceName": "Regions.BRUNEI_DARUSSALAM",
				// BND
				"defaultCurrencyId": "CE85462C-4A0C-492A-9613-CD7BC4FF833F"
			},
			{
				"id": 23,
				"resourceName": "Regions.BULGARIA",
				// BGN
				"defaultCurrencyId": "BAAC2BD9-0E06-43D0-BDA9-624B7330ABD8"
			},
			{
				"id": 21,
				"resourceName": "Regions.BURKINA_FASO",
				// XOF
				"defaultCurrencyId": "1AFB48F1-485B-47AB-A67C-9DF4A9D08216"
			},
			{
				"id": 18,
				"resourceName": "Regions.BURUNDI",
				// BIF
				"defaultCurrencyId": "355F738A-5AFB-42EF-8299-6D330051C797"
			},
			{
				"id": 114,
				"resourceName": "Regions.CAMBODIA",
				// KHR
				"defaultCurrencyId": "2904A9AB-8DD4-4526-AA7C-AAFBBC00395E"
			},
			{
				"id": 44,
				"resourceName": "Regions.CAMEROON",
				// XAF
				"defaultCurrencyId": "EEB2055A-904B-4B6A-9C1E-7D0F4B7C2E40"
			},
			{
				"id": 38,
				"resourceName": "Regions.CANADA",
				// CAD
				"defaultCurrencyId": "1c32d81e-57c4-11e3-8b35-c7986188709b"
			},
			{
				"id": 49,
				"resourceName": "Regions.CAPE_VERDE",
				// CVE
				"defaultCurrencyId": "38ACF1A0-57C4-11E3-A1A2-00996188709B"
			},
			{
				"id": 53,
				"resourceName": "Regions.CAYMAN_ISLANDS",
				// KYD
				"defaultCurrencyId": "58D1E36D-E717-4EAC-9D83-A5C6A76789A6"
			},
			{
				"id": 37,
				"resourceName": "Regions.CENTRAL_AFRICAN_REPUBLIC",
				// XAF
				"defaultCurrencyId": "EEB2055A-904B-4B6A-9C1E-7D0F4B7C2E40"
			},
			{
				"id": 205,
				"resourceName": "Regions.CHAD",
				// XAF
				"defaultCurrencyId": "EEB2055A-904B-4B6A-9C1E-7D0F4B7C2E40"
			},
			{
				"id": 41,
				"resourceName": "Regions.CHILE",
				// CLP
				"defaultCurrencyId": "32262BBC-57C4-11E3-8F9C-DB986188709B"
			},
			{
				"id": 42,
				"resourceName": "Regions.CHINA",
				//CNY
				"defaultCurrencyId": "34a8054a-57c4-11e3-97ef-dc986188709b"
			},
			{
				"id": 52,
				"resourceName": "Regions.CHRISTMAS_ISLAND",
				"defaultCurrencyId": ""
			},
			{
				"id": 39,
				"resourceName": "Regions.COCOA_KEELING_ISLANDS_1",
				// AUD
				"defaultCurrencyId": "271C7DD4-57C4-11E3-A267-D2986188709B"
			},
			{
				"id": 47,
				"resourceName": "Regions.COLOMBIA",
				//COP
				"defaultCurrencyId": "364b68e2-57c4-11e3-ba6c-dd986188709b"
			},
			{
				"id": 48,
				"resourceName": "Regions.COMOROS",
				// KMF
				"defaultCurrencyId": "FA21DCB9-6E3E-4C12-BB27-4030EC457325"
			},
			{
				"id": 45,
				"resourceName": "Regions.CONGO",
				// XAF
				"defaultCurrencyId": "EEB2055A-904B-4B6A-9C1E-7D0F4B7C2E40"
			},
			{
				"id": 46,
				"resourceName": "Regions.COOK_ISLANDS",
				// NZD
				"defaultCurrencyId": "5B8BB396-57C4-11E3-8FD7-19996188709B"
			},
			{
				"id": 50,
				"resourceName": "Regions.COSTA_RICA",
				// CRC
				"defaultCurrencyId": "9CCE41FF-778B-4856-A51B-B4C877D6E1D1"
			},
			{
				"id": 43,
				"resourceName": "Regions.COTE_DIVOIRE",
				"defaultCurrencyId": ""
			},
			{
				"id": 96,
				"resourceName": "Regions.CROATIA",
				// HRK
				"defaultCurrencyId": "421B9444-57C4-11E3-BCF5-05996188709B"
			},
			{
				"id": 51,
				"resourceName": "Regions.CUBA",
				// CUP
				"defaultCurrencyId": "00EA1CFA-71A2-4AC6-BD46-B130EE10EDD2"
			},
			{
				"id": 54,
				"resourceName": "Regions.CYPRUS",
				//EUR
				"defaultCurrencyId": "1ef1cbf0-57c4-11e3-ab91-cb986188709b"
			},
			{
				"id": 55,
				"resourceName": "Regions.CZECH_REPUBLIC",
				// CZK
				"defaultCurrencyId": "3A880370-57C4-11E3-9197-01996188709B"
			},
			{
				"id": 238,
				"resourceName": "Regions.DEMOCRATIC_REPUBLIC_OF_THE_CONGO",
				"defaultCurrencyId": ""
			},
			{
				"id": 59,
				"resourceName": "Regions.DENMARK",
				// DKK
				"defaultCurrencyId": "3C3CC476-57C4-11E3-9560-02996188709B"
			},
			{
				"id": 57,
				"resourceName": "Regions.DJIBOUTI",
				// DJF
				"defaultCurrencyId": "542467E0-D048-4787-82D7-C201977950E5"
			},
			{
				"id": 58,
				"resourceName": "Regions.DOMINICA",
				// XCD
				"defaultCurrencyId": "8E93696F-889D-4147-89DA-F865D668ABD9"
			},
			{
				"id": 60,
				"resourceName": "Regions.DOMINICAN_REPUBLIC",
				// DOP
				"defaultCurrencyId": "B5CB9D89-A2AF-4A28-A1AA-757AED93587A"
			},
			{
				"id": 211,
				"resourceName": "Regions.EAST_TIMOR",
				// USD
				"defaultCurrencyId": "1994DD50-57C4-11E3-9C0D-BD986188709B"
			},
			{
				"id": 62,
				"resourceName": "Regions.ECUADOR",
				// USD
				"defaultCurrencyId": "1994DD50-57C4-11E3-9C0D-BD986188709B"
			},
			{
				"id": 63,
				"resourceName": "Regions.EGYPT",
				// EGP
				"defaultCurrencyId": "3DEF937A-57C4-11E3-819B-03996188709B"
			},
			{
				"id": 192,
				"resourceName": "Regions.EL_SALVADOR",
				// USD
				"defaultCurrencyId": "1994DD50-57C4-11E3-9C0D-BD986188709B"
			},
			{
				"id": 85,
				"resourceName": "Regions.EQUATORIAL_GUINEA",
				// XAF
				"defaultCurrencyId": "EEB2055A-904B-4B6A-9C1E-7D0F4B7C2E40"
			},
			{
				"id": 64,
				"resourceName": "Regions.ERITREA",
				// ERN
				"defaultCurrencyId": "71CEEEFA-64EA-47F9-8001-DE6465D87945"
			},
			{
				"id": 67,
				"resourceName": "Regions.ESTONIA",
				//EUR
				"defaultCurrencyId": "1ef1cbf0-57c4-11e3-ab91-cb986188709b"
			},
			{
				"id": 68,
				"resourceName": "Regions.ETHIOPIA",
				// ETB
				"defaultCurrencyId": "4273B4B1-B64E-4FFC-A410-F9AFF5692FCB"
			},
			{
				"id": 71,
				"resourceName": "Regions.FALKLAND_ISLANDS_MALVINAS",
				// FKP
				"defaultCurrencyId": "EFECB1E6-51B6-4C7C-B5E4-DC0A08DBB1E1"
			},
			{
				"id": 73,
				"resourceName": "Regions.FAROE_ISLANDS",
				// DKK
				"defaultCurrencyId": "3C3CC476-57C4-11E3-9560-02996188709B"
			},
			{
				"id": 70,
				"resourceName": "Regions.FIJI",
				// FJD
				"defaultCurrencyId": "174F03D7-9266-48C3-B67F-63D03BFE4198"
			},
			{
				"id": 69,
				"resourceName": "Regions.FINLAND",
				//EUR
				"defaultCurrencyId": "1ef1cbf0-57c4-11e3-ab91-cb986188709b"
			},
			{
				"id": 72,
				"resourceName": "Regions.FRANCE",
				//EUR
				"defaultCurrencyId": "1ef1cbf0-57c4-11e3-ab91-cb986188709b"
			},
			{
				"id": 75,
				"resourceName": "Regions.FRANCE_METROPOLITAN",
				//EUR
				"defaultCurrencyId": "1ef1cbf0-57c4-11e3-ab91-cb986188709b"
			},
			{
				"id": 90,
				"resourceName": "Regions.FRENCH_GUIANA",
				//EUR
				"defaultCurrencyId": "1ef1cbf0-57c4-11e3-ab91-cb986188709b"
			},
			{
				"id": 177,
				"resourceName": "Regions.FRENCH_POLYNESIA",
				// XPF
				"defaultCurrencyId": "1C5FB0E3-C917-4E07-8684-8847BB73D789"
			},
			{
				"id": 13,
				"resourceName": "Regions.FRENCH_SOUTHERN_TERRITORIES",
				//EUR
				"defaultCurrencyId": "1ef1cbf0-57c4-11e3-ab91-cb986188709b"
			},
			{
				"id": 76,
				"resourceName": "Regions.GABON",
				// XAF
				"defaultCurrencyId": "EEB2055A-904B-4B6A-9C1E-7D0F4B7C2E40"

			},
			{
				"id": 83,
				"resourceName": "Regions.GAMBIA",
				// GMD
				"defaultCurrencyId": "E901DF43-6FA4-4FAC-96B1-4DF9CBE575EA"
			},
			{
				"id": 78,
				"resourceName": "Regions.GEORGIA",
				// GEL
				"defaultCurrencyId": "644E6A8C-4CCA-46DF-AFAC-55DF06C9CA58"
			},
			{
				"id": 56,
				"resourceName": "Regions.GERMANY",
				//EUR
				"defaultCurrencyId": "1ef1cbf0-57c4-11e3-ab91-cb986188709b"
			},
			{
				"id": 79,
				"resourceName": "Regions.GHANA",
				// GHS
				"defaultCurrencyId": "6ABCF735-CCDE-4DC4-A699-4E8E8C66677D"
			},
			{
				"id": 80,
				"resourceName": "Regions.GIBRALTAR",
				// GIP
				"defaultCurrencyId": "E70740D8-14E8-48C7-BCD7-DF977D00FA5B"
			},
			{
				"id": 86,
				"resourceName": "Regions.GREECE",
				//EUR
				"defaultCurrencyId": "1ef1cbf0-57c4-11e3-ab91-cb986188709b"
			},
			{
				"id": 88,
				"resourceName": "Regions.GREENLAND",
				"defaultCurrencyId": ""
			},
			{
				"id": 87,
				"resourceName": "Regions.GRENADA",
				// XCD
				"defaultCurrencyId": "8E93696F-889D-4147-89DA-F865D668ABD9"
			},
			{
				"id": 82,
				"resourceName": "Regions.GUADELOUPE",
				"defaultCurrencyId": ""
			},
			{
				"id": 91,
				"resourceName": "Regions.GUAM",
				"defaultCurrencyId": ""
			},
			{
				"id": 89,
				"resourceName": "Regions.GUATEMALA",
				// GTQ
				"defaultCurrencyId": "CC0A48C4-A970-446C-9487-F82AF322C59C"
			},
			{
				"id": 81,
				"resourceName": "Regions.GUINEA",
				// GNF
				"defaultCurrencyId": "E113A328-EE02-4C5C-B319-F615E305C9A0"
			},
			{
				"id": 84,
				"resourceName": "Regions.GUINEA_BISSAU",
				// XOF
				"defaultCurrencyId": "1AFB48F1-485B-47AB-A67C-9DF4A9D08216"
			},
			{
				"id": 92,
				"resourceName": "Regions.GUYANA",
				// GYD
				"defaultCurrencyId": "EBAE43D8-69E6-43BE-9F18-925EDCE606FC"
			},
			{
				"id": 97,
				"resourceName": "Regions.HAITI",
				// HTG
				"defaultCurrencyId": "A4648BEF-E77D-4FA9-9EE4-A1C491006056"
			},
			{
				"id": 94,
				"resourceName": "Regions.HEARD_AND_MC_DONALD_ISLANDS",
				"defaultCurrencyId": ""
			},
			{
				"id": 95,
				"resourceName": "Regions.HONDURAS",
				// HNL
				"defaultCurrencyId": "B23ED0A7-4B76-4824-A742-A1CE43C501AF"
			},
			{
				"id": 93,
				"resourceName": "Regions.HONG_KONG",
				// HKD
				"defaultCurrencyId": "762E8BE6-E78D-49DB-97A8-2009F015244E"
			},
			{
				"id": 98,
				"resourceName": "Regions.HUNGARY",
				// HUF
				"defaultCurrencyId": "6CCB6A2A-00C9-49DF-8401-C3A9132C901D"
			},
			{
				"id": 105,
				"resourceName": "Regions.ICELAND",
				// ISK
				"defaultCurrencyId": "476C1018-57C4-11E3-A9FC-0B996188709B"
			},
			{
				"id": 100,
				"resourceName": "Regions.INDIA",
				//INR
				"defaultCurrencyId": "45575f9e-57c4-11e3-99f3-0a996188709b"
			},
			{
				"id": 99,
				"resourceName": "Regions.INDONESIA",
				// IDR
				"defaultCurrencyId": "71E79873-EC42-4DBA-AEA3-72B61B0E6A2B"
			},
			{
				"id": 103,
				"resourceName": "Regions.IRAN_ISLAMIC_REPUBLIC_OF",
				// IRR
				"defaultCurrencyId": "969FA1BF-FDFD-4565-8C94-E4EB3DF01F5B"
			},
			{
				"id": 104,
				"resourceName": "Regions.IRAQ",
				// IQD
				"defaultCurrencyId": "418F7B30-C556-4154-B79E-F1382CF2E14D"
			},
			{
				"id": 102,
				"resourceName": "Regions.IRELAND",
				//EUR
				"defaultCurrencyId": "1ef1cbf0-57c4-11e3-ab91-cb986188709b"
			},
			{
				"id": 106,
				"resourceName": "Regions.ISRAEL",
				// ILS
				"defaultCurrencyId": "439C37CE-57C4-11E3-998C-09996188709B"
			},
			{
				"id": 107,
				"resourceName": "Regions.ITALY",
				//EUR
				"defaultCurrencyId": "1ef1cbf0-57c4-11e3-ab91-cb986188709b"
			},
			{
				"id": 108,
				"resourceName": "Regions.JAMAICA",
				// JMD
				"defaultCurrencyId": "79270C9A-9904-4398-BDA9-2EAEE86B26D2"
			},
			{
				"id": 110,
				"resourceName": "Regions.JAPAN",
				//JPY
				"defaultCurrencyId": "49376fc8-57c4-11e3-a5c7-0c996188709b"
			},
			{
				"id": 109,
				"resourceName": "Regions.JORDAN",
				// JOD
				"defaultCurrencyId": "C339B194-9A00-4C67-B8D2-C3EDCEFF2A66"
			},
			{
				"id": 111,
				"resourceName": "Regions.KAZAKHSTAN",
				// KZT
				"defaultCurrencyId": "43960838-22F6-4C51-A830-84C315A75610"
			},
			{
				"id": 112,
				"resourceName": "Regions.KENYA",
				// KES
				"defaultCurrencyId": "5E74555D-2BD8-4138-8CA6-C6299F497C68"
			},
			{
				"id": 115,
				"resourceName": "Regions.KIRIBATI",
				// AUD
				"defaultCurrencyId": "271C7DD4-57C4-11E3-A267-D2986188709B"
			},
			{
				"id": 117,
				"resourceName": "Regions.KOREA_REPUBLIC_OF",
				//KRW
				"defaultCurrencyId": "4abe4204-57c4-11e3-aea9-0d996188709b"
			},
			{
				"id": 174,
				"resourceName": "Regions.KOREA_DEMOCRATIC_PEOPLES_REPUBLIC_OF",
				// KPW
				"defaultCurrencyId": "E878B8A0-07D2-4329-80BE-7F7FB3E072D6"
			},
			{
				"id": 118,
				"resourceName": "Regions.KUWAIT",
				// KWD
				"defaultCurrencyId": "4C5C4192-57C4-11E3-AA29-0E996188709B"

			},
			{
				"id": 113,
				"resourceName": "Regions.KYRGYZSTAN",
				// KGS
				"defaultCurrencyId": "F16D5306-F0B4-4B55-878F-9E84D943C28E"
			},
			{
				"id": 119,
				"resourceName": "Regions.LAO_PEOPLES_DEMOCRATIC_REPUBLIC",
				// LAK
				"defaultCurrencyId": "D950CFC0-1EB2-4C0B-895B-EFFE6B418651"
			},
			{
				"id": 129,
				"resourceName": "Regions.LATVIA",
				//EUR
				"defaultCurrencyId": "1ef1cbf0-57c4-11e3-ab91-cb986188709b"
			},
			{
				"id": 120,
				"resourceName": "Regions.LEBANON",
				// LBP
				"defaultCurrencyId": "4E026698-57C4-11E3-813A-0F996188709B"
			},
			{
				"id": 126,
				"resourceName": "Regions.LESOTHO",
				// LSL
				"defaultCurrencyId": "1A581A68-596F-4C74-922A-F774A79868FD"
			},
			{
				"id": 121,
				"resourceName": "Regions.LIBERIA",
				// LRD
				"defaultCurrencyId": "5854ADD6-65EE-4C21-9651-9660E1CC7A22"
			},
			{
				"id": 122,
				"resourceName": "Regions.LIBYAN_ARAB_JAMAHIRIYA",
				// LYD
				"defaultCurrencyId": "08F3F661-6F6E-4064-8166-8D6AB5A51389"
			},
			{
				"id": 124,
				"resourceName": "Regions.LIECHTENSTEIN",
				// CHF
				"defaultCurrencyId": "30774FBC-57C4-11E3-A88C-D7986188709B"
			},
			{
				"id": 127,
				"resourceName": "Regions.LITHUANIA",
				// EUR
				"defaultCurrencyId": "1EF1CBF0-57C4-11E3-AB91-CB986188709B"
			},
			{
				"id": 128,
				"resourceName": "Regions.LUXEMBOURG",
				//EUR
				"defaultCurrencyId": "1ef1cbf0-57c4-11e3-ab91-cb986188709b"
			},
			{
				"id": 130,
				"resourceName": "Regions.MACAU",
				// MOP
				"defaultCurrencyId": "C01B8CE3-5F1C-4EB3-8A72-AFEA404C4D7D"
			},
			{
				"id": 138,
				"resourceName": "Regions.MACEDONIA",
				// MKD
				"defaultCurrencyId": "A6B05143-B185-4524-9F5C-EA485EDD3DFE"
			},
			{
				"id": 134,
				"resourceName": "Regions.MADAGASCAR",
				// MGA
				"defaultCurrencyId": "9F56F7E1-E077-4547-9447-0B60F8C2F58D"
			},
			{
				"id": 150,
				"resourceName": "Regions.MALAWI",
				// MWK
				"defaultCurrencyId": "AF1CD06B-840F-41CD-87D5-A85C96A5FA44"
			},
			{
				"id": 151,
				"resourceName": "Regions.MALAYSIA",
				// MYR
				"defaultCurrencyId": "896C01AF-5B20-4300-8ECF-85B39DDBA6FA"
			},
			{
				"id": 135,
				"resourceName": "Regions.MALDIVES",
				// MVR
				"defaultCurrencyId": "A84093B9-EDE0-4A14-B414-165DE74DE481"
			},
			{
				"id": 139,
				"resourceName": "Regions.MALI",
				// XOF
				"defaultCurrencyId": "1AFB48F1-485B-47AB-A67C-9DF4A9D08216"
			},
			{
				"id": 140,
				"resourceName": "Regions.MALTA",
				//EUR
				"defaultCurrencyId": "1ef1cbf0-57c4-11e3-ab91-cb986188709b"
			},
			{
				"id": 137,
				"resourceName": "Regions.MARSHALL_ISLANDS",
				// USD
				"defaultCurrencyId": "1994DD50-57C4-11E3-9C0D-BD986188709B"
			},
			{
				"id": 148,
				"resourceName": "Regions.MARTINIQUE",
				"defaultCurrencyId": ""
			},
			{
				"id": 146,
				"resourceName": "Regions.MAURITANIA",
				// MRU
				"defaultCurrencyId": "8569CED5-F85B-4214-93C9-32495FF1F69B"
			},
			{
				"id": 149,
				"resourceName": "Regions.MAURITIUS",
				// MUR
				"defaultCurrencyId": "515154BC-57C4-11E3-8326-11996188709B"
			},
			{
				"id": 152,
				"resourceName": "Regions.MAYOTTE",
				"defaultCurrencyId": ""
			},
			{
				"id": 136,
				"resourceName": "Regions.MEXICO",
				//MXN
				"defaultCurrencyId": "53a184d0-57c4-11e3-9512-12996188709b"
			},
			{
				"id": 74,
				"resourceName": "Regions.MICRONESIA_FEDERATED_STATES_OF",
				// USD
				"defaultCurrencyId": "1994DD50-57C4-11E3-9C0D-BD986188709B"
			},
			{
				"id": 133,
				"resourceName": "Regions.MOLDOVA_REPUBLIC_OF",
				// MDL
				"defaultCurrencyId": "DF66DA07-35A2-4A29-BF51-D89C7B8CF1C0"
			},
			{
				"id": 132,
				"resourceName": "Regions.MONACO",
				// EUR
				"defaultCurrencyId": "1EF1CBF0-57C4-11E3-AB91-CB986188709B"
			},
			{
				"id": 142,
				"resourceName": "Regions.MONGOLIA",
				// MNT
				"defaultCurrencyId": "7D39B34F-298D-47B5-9544-B5137F3E3A26"
			},
			{
				"id": 147,
				"resourceName": "Regions.MONTSERRAT",
				// XCD
				"defaultCurrencyId": "8E93696F-889D-4147-89DA-F865D668ABD9"
			},
			{
				"id": 131,
				"resourceName": "Regions.MOROCCO",
				// MAD
				"defaultCurrencyId": "4F8C15FE-57C4-11E3-B056-10996188709B"
			},
			{
				"id": 145,
				"resourceName": "Regions.MOZAMBIQUE",
				// MZN
				"defaultCurrencyId": "5635B84C-57C4-11E3-83A4-16996188709B"
			},
			{
				"id": 141,
				"resourceName": "Regions.MYANMAR",
				// MMK
				"defaultCurrencyId": "2366B15F-2999-4112-8A52-FC24136FD432"
			},
			{
				"id": 153,
				"resourceName": "Regions.NAMIBIA",
				// NAD
				"defaultCurrencyId": "584DFC34-57C4-11E3-A18D-17996188709B"
			},
			{
				"id": 162,
				"resourceName": "Regions.NAURU",
				// AUD
				"defaultCurrencyId": "271C7DD4-57C4-11E3-A267-D2986188709B"
			},
			{
				"id": 161,
				"resourceName": "Regions.NEPAL",
				// Nepal
				// NPR
				"defaultCurrencyId": "0E9156BB-FD46-4C65-AD16-BF002C55162B"
			},
			{
				"id": 160,
				"resourceName": "Regions.NETHERLANDS",
				//EUR
				"defaultCurrencyId": "1ef1cbf0-57c4-11e3-ab91-cb986188709b"
			},
			{
				"id": 7,
				"resourceName": "Regions.NETHERLANDS_ANTILLES",
				"defaultCurrencyId": ""
			},
			{
				"id": 154,
				"resourceName": "Regions.NEW_CALEDONIA",
				// XPF
				"defaultCurrencyId": "1C5FB0E3-C917-4E07-8684-8847BB73D789"
			},
			{
				"id": 163,
				"resourceName": "Regions.NEW_ZEALAND",
				//NZD
				"defaultCurrencyId": "5b8bb396-57c4-11e3-8fd7-19996188709b"
			},
			{
				"id": 158,
				"resourceName": "Regions.NICARAGUA",
				// NIO
				"defaultCurrencyId": "462EE131-A248-46B9-9E46-0FD52B5A1B23"
			},
			{
				"id": 155,
				"resourceName": "Regions.NIGER",
				// XOF
				"defaultCurrencyId": "1AFB48F1-485B-47AB-A67C-9DF4A9D08216"
			},
			{
				"id": 157,
				"resourceName": "Regions.NIGERIA",
				// NGN
				"defaultCurrencyId": "30975DE5-D503-48E3-90CF-54EC762F5382"
			},
			{
				"id": 159,
				"resourceName": "Regions.NIUE",
				// NZD
				"defaultCurrencyId": "5B8BB396-57C4-11E3-8FD7-19996188709B"
			},
			{
				"id": 156,
				"resourceName": "Regions.NORFOLK_ISLAND",
				"defaultCurrencyId": ""
			},
			{
				"id": 143,
				"resourceName": "Regions.NORTHERN_MARIANA_ISLANDS",
				"defaultCurrencyId": ""
			},
			{
				"id": 144,
				"resourceName": "Regions.NORWAY",
				// NOK
				"defaultCurrencyId": "59D86CBA-57C4-11E3-B209-18996188709B"
			},
			{
				"id": 222,
				"resourceName": "Regions.NOT_LISTED",
				"defaultCurrencyId": ""
			},
			{
				"id": 164,
				"resourceName": "Regions.OMAN",
				// OMR
				"defaultCurrencyId": "F5FC2170-96CF-40ED-89CF-0FF3DD205AD9"
			},
			{
				"id": 165,
				"resourceName": "Regions.PAKISTAN",
				// PKR
				"defaultCurrencyId": "7B98CB05-06C3-4640-BAF8-DF484F47E3BC"
			},
			{
				"id": 170,
				"resourceName": "Regions.PALAU",
				// USD
				"defaultCurrencyId": "1994DD50-57C4-11E3-9C0D-BD986188709B"
			},
			{
				"id": 166,
				"resourceName": "Regions.PANAMA",
				// PAB
				"defaultCurrencyId": "54469043-BB83-4885-A00E-A40DCBCC2700"
			},
			{
				"id": 171,
				"resourceName": "Regions.PAPUA_NEW_GUINEA",
				// PGK
				"defaultCurrencyId": "E3CF77C0-3EDF-480B-87CA-77DA05E6E735"
			},
			{
				"id": 176,
				"resourceName": "Regions.PARAGUAY",
				// PYG
				"defaultCurrencyId": "5EFCE7AE-F801-46DB-BDA1-93DC8F55C115"
			},
			{
				"id": 168,
				"resourceName": "Regions.PERU",
				// Peru
				// PEN
				"defaultCurrencyId": "5D227190-57C4-11E3-8447-1A996188709B"
			},
			{
				"id": 169,
				"resourceName": "Regions.PHILIPPINES",
				//PHP
				"defaultCurrencyId": "5ea971c6-57c4-11e3-9c07-1d996188709b"
			},
			{
				"id": 167,
				"resourceName": "Regions.PITCAIRN",
				// NZD
				"defaultCurrencyId": "5B8BB396-57C4-11E3-8FD7-19996188709B"
			},
			{
				"id": 172,
				"resourceName": "Regions.POLAND",
				// PLN
				"defaultCurrencyId": "6030B43C-57C4-11E3-8170-1F996188709B"
			},
			{
				"id": 175,
				"resourceName": "Regions.PORTUGAL",
				//EUR
				"defaultCurrencyId": "1ef1cbf0-57c4-11e3-ab91-cb986188709b"
			},
			{
				"id": 173,
				"resourceName": "Regions.PUERTO_RICO",
				"defaultCurrencyId": ""
			},
			{
				"id": 178,
				"resourceName": "Regions.QATAR",
				// QAR
				"defaultCurrencyId": "6188DA89-A94C-488F-B1B1-E51185D86E1B"
			},
			{
				"id": 179,
				"resourceName": "Regions.REUNION",
				"defaultCurrencyId": ""
			},
			{
				"id": 180,
				"resourceName": "Regions.ROMANIA",
				// RON
				"defaultCurrencyId": "19C21628-BA48-4F60-8399-6AC8D48F6E9B"
			},
			{
				"id": 181,
				"resourceName": "Regions.RUSSIAN_FEDERATION",
				// RUB
				"defaultCurrencyId": "62316236-57C4-11E3-90A4-23996188709B"
			},
			{
				"id": 182,
				"resourceName": "Regions.RWANDA",
				// RWF
				"defaultCurrencyId": "F38E4F74-3556-4E0D-8090-D54CAC57D58E"
			},
			{
				"id": 116,
				"resourceName": "Regions.SAINT_KITTS_AND_NEVIS",
				// XCD
				"defaultCurrencyId": "8E93696F-889D-4147-89DA-F865D668ABD9"
			},
			{
				"id": 123,
				"resourceName": "Regions.SAINT_LUCIA",
				// XCD
				"defaultCurrencyId": "8E93696F-889D-4147-89DA-F865D668ABD9"
			},
			{
				"id": 227,
				"resourceName": "Regions.SAINT_VINCENT_AND_THE_GRENADINES",
				// XCD
				"defaultCurrencyId": "8E93696F-889D-4147-89DA-F865D668ABD9"
			},
			{
				"id": 234,
				"resourceName": "Regions.SAMOA",
				// WST
				"defaultCurrencyId": "EAA7A4DD-1E12-4547-9DBA-19F10AA18F81"
			},
			{
				"id": 193,
				"resourceName": "Regions.SAN_MARINO",
				// EUR
				"defaultCurrencyId": "1EF1CBF0-57C4-11E3-AB91-CB986188709B"
			},
			{
				"id": 196,
				"resourceName": "Regions.SAO_TOME_AND_PRINCIPE",
				"defaultCurrencyId": ""
			},
			{
				"id": 183,
				"resourceName": "Regions.SAUDI_ARABIA",
				// SAR
				"defaultCurrencyId": "D385FB5D-5734-4D2A-82C7-C31DA042114D"
			},
			{
				"id": 185,
				"resourceName": "Regions.SENEGAL",
				// XOF
				"defaultCurrencyId": "1AFB48F1-485B-47AB-A67C-9DF4A9D08216"
			},
			{
				"id": 236,
				"resourceName": "Regions.SERBIA",
				// RSD
				"defaultCurrencyId": "8F68D429-FD38-4899-A915-2B35E8CA5210"
			},
			{
				"id": 202,
				"resourceName": "Regions.SEYCHELLES",
				// SCR
				"defaultCurrencyId": "6723B3F2-57C4-11E3-A9D8-29996188709B"
			},
			{
				"id": 191,
				"resourceName": "Regions.SIERRA_LEONE",
				// SLL
				"defaultCurrencyId": "A902942D-CF2F-4663-A2C9-7DD8CF8553B5"
			},
			{
				"id": 186,
				"resourceName": "Regions.SINGAPORE",
				// SGD
				"defaultCurrencyId": "8D55C7DD-D545-4A83-9439-69F7407DCF76"
			},
			{
				"id": 198,
				"resourceName": "Regions.SLOVAKIA_SLOVAK_REPUBLIC",
				//EUR
				"defaultCurrencyId": "1ef1cbf0-57c4-11e3-ab91-cb986188709b"
			},
			{
				"id": 199,
				"resourceName": "Regions.SLOVENIA",
				//EUR
				"defaultCurrencyId": "1ef1cbf0-57c4-11e3-ab91-cb986188709b"
			},
			{
				"id": 190,
				"resourceName": "Regions.SOLOMON_ISLANDS",
				// SBD
				"defaultCurrencyId": "363B6C7B-66C8-4A29-8B33-E00D01238DA6"
			},
			{
				"id": 194,
				"resourceName": "Regions.SOMALIA",
				// SOS
				"defaultCurrencyId": "D001DAEF-5B00-449C-815A-0E18083F6E92"
			},
			{
				"id": 237,
				"resourceName": "Regions.SOUTH_AFRICA",
				//ZAR
				"defaultCurrencyId": "6ec532b6-57c4-11e3-9779-31996188709b"
			},
			{
				"id": 187,
				"resourceName": "Regions.SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS",
				"defaultCurrencyId": ""
			},
			{
				"id": 66,
				"resourceName": "Regions.SPAIN",
				//EUR
				"defaultCurrencyId": "1ef1cbf0-57c4-11e3-ab91-cb986188709b"
			},
			{
				"id": 125,
				"resourceName": "Regions.SRI_LANKA",
				// LKR
				"defaultCurrencyId": "86C7792D-70EA-49D2-A3C3-488F09682526"
			},
			{
				"id": 188,
				"resourceName": "Regions.ST_HELENA",
				// SHP
				"defaultCurrencyId": "58489927-5FC7-406B-B181-9CD58EA0D6AD"
			},
			{
				"id": 195,
				"resourceName": "Regions.ST_PIERRE_AND_MIQUELON",
				"defaultCurrencyId": ""
			},
			{
				"id": 184,
				"resourceName": "Regions.SUDAN",
				// SDG
				"defaultCurrencyId": "DA06F778-2131-4C8E-8361-9AF860C88122"
			},
			{
				"id": 197,
				"resourceName": "Regions.SURINAME",
				// SRD
				"defaultCurrencyId": "61E29729-E851-44A7-95D1-196BD0E9E2E8"
			},
			{
				"id": 189,
				"resourceName": "Regions.SVALBARD_AND_JAN_MAYEN_ISLANDS",
				"defaultCurrencyId": ""
			},
			{
				"id": 201,
				"resourceName": "Regions.SWAZILAND",
				// SZL
				"defaultCurrencyId": "F9C9D402-D63E-4629-A8B6-F2B463DEA52C"
			},
			{
				"id": 200,
				"resourceName": "Regions.SWEDEN",
				// SEK
				"defaultCurrencyId": "69968614-57C4-11E3-A655-2A996188709B"
			},
			{
				"id": 40,
				"resourceName": "Regions.SWITZERLAND",
				// CHF
				"defaultCurrencyId": "30774FBC-57C4-11E3-A88C-D7986188709B"
			},
			{
				"id": 203,
				"resourceName": "Regions.SYRIAN_ARAB_REPUBLIC",
				// SYP
				"defaultCurrencyId": "F386369C-DC73-4E2C-9F84-3B05D656B5FE"
			},
			{
				"id": 217,
				"resourceName": "Regions.TAIWAN",
				// TWD
				"defaultCurrencyId": "4A7E7519-0FDB-44F3-8853-814DD2E9F4D8"
			},
			{
				"id": 208,
				"resourceName": "Regions.TAJIKISTANA",
				// TJS
				"defaultCurrencyId": "9F9E1C3A-0BAA-4421-A1CE-10883C8588D5"
			},
			{
				"id": 218,
				"resourceName": "Regions.TANZANIA_UNITED_REPUBLIC_OF",
				// TZS
				"defaultCurrencyId": "70040244-4C0C-4AB0-9C5D-D1DFB3BFA0C7"
			},
			{
				"id": 207,
				"resourceName": "Regions.THAILAND",
				// THB
				"defaultCurrencyId": "6B4C01BE-57C4-11E3-A89D-2B996188709B"
			},
			{
				"id": 206,
				"resourceName": "Regions.TOGO",
				// XOF
				"defaultCurrencyId": "1AFB48F1-485B-47AB-A67C-9DF4A9D08216"
			},
			{
				"id": 209,
				"resourceName": "Regions.TOKELAU",
				"defaultCurrencyId": ""
			},
			{
				"id": 212,
				"resourceName": "Regions.TONGA",
				// TOP
				"defaultCurrencyId": "C6EE712E-0959-4EEF-A906-CE97CD8C3EE2"
			},
			{
				"id": 213,
				"resourceName": "Regions.TRINIDAD_AND_TOBAGO",
				// TTD
				"defaultCurrencyId": "7DD589EA-C678-4265-BA49-9E12DAF0F58E"
			},
			{
				"id": 214,
				"resourceName": "Regions.TUNISIA",
				// TND
				"defaultCurrencyId": "B5DAEFA9-EA54-4FDF-BD6D-D190A848607E"
			},
			{
				"id": 215,
				"resourceName": "Regions.TURKEY",
				// TRY
				"defaultCurrencyId": "C1C6D163-7AFD-456C-8293-639F59A9D0F0"
			},
			{
				"id": 210,
				"resourceName": "Regions.TURKMENISTAN",
				// TMT
				"defaultCurrencyId": "F071B3BC-CE36-4575-B642-3F09227B56A4"
			},
			{
				"id": 204,
				"resourceName": "Regions.TURKS_AND_CAICOS_ISLANDS",
				// USD
				"defaultCurrencyId": "1994DD50-57C4-11E3-9C0D-BD986188709B"
			},
			{
				"id": 216,
				"resourceName": "Regions.TUVALU",
				// TVD
				"defaultCurrencyId": "8F56C701-AB80-4D94-B460-F0FD8FC3DC86"
			},
			{
				"id": 219,
				"resourceName": "Regions.UGANDA",
				// UGX
				"defaultCurrencyId": "6CF8FD14-57C4-11E3-A850-2C996188709B"
			},
			{
				"id": 220,
				"resourceName": "Regions.UKRAINE",
				// UAH
				"defaultCurrencyId": "3C605747-4FD1-436D-AF09-BC764F3F953A"
			},
			{
				"id": 8,
				"resourceName": "Regions.UNITED_ARAB_EMIRATES",
				// AED
				"defaultCurrencyId": "21B75292-57C4-11E3-B047-D0986188709B"
			},
			{
				"id": 77,
				"resourceName": "Regions.UNITED_KINGDOM",
				//GBP
				"defaultCurrencyId": "402f86fe-57c4-11e3-9690-04996188709b"
			},
			{
				"id": 221,
				"resourceName": "Regions.UNITED_STATES_MINOR_OUTLYING_ISLANDS",
				// USD
				"defaultCurrencyId": "1994DD50-57C4-11E3-9C0D-BD986188709B"
			},
			{
				"id": 223,
				"resourceName": "Regions.URUGUAY",
				// UYU
				"defaultCurrencyId": "CC089271-DF7F-4253-9852-85D3BA941228"
			},
			{
				"id": 224,
                "resourceName": "Regions.UNITED_STATES",
				// USD
				"defaultCurrencyId": "1994dd50-57c4-11e3-9c0d-bd986188709b"
			},
			{
				"id": 225,
				"resourceName": "Regions.UZBEKISTAN",
				// UZS
				"defaultCurrencyId": "57DB825A-038D-42DB-909E-4EBEE0F45731"
			},
			{
				"id": 232,
				"resourceName": "Regions.VANUATU",
				// VUV
				"defaultCurrencyId": "CDA62FF8-2540-4CAC-8ADA-4A8AE1E968F4"
			},
			{
				"id": 226,
				"resourceName": "Regions.VATICAN_CITY_STATE_HOLY_SEE",
				// EUR
				"defaultCurrencyId": "1EF1CBF0-57C4-11E3-AB91-CB986188709B"
			},
			{
				"id": 228,
				"resourceName": "Regions.VENEZUELA",
				// VEF
				"defaultCurrencyId": "5A159237-5856-4E92-BD6C-7692E0B8E155"
			},
			{
				"id": 231,
				"resourceName": "Regions.VIET_NAM",
				// VND
				"defaultCurrencyId": "3D7D0D5A-C269-4323-B37D-D4A6DC26AE78"
			},
			{
				"id": 229,
				"resourceName": "Regions.VIRGIN_ISLANDS_BRITISH",
				// USD
				"defaultCurrencyId": "1994DD50-57C4-11E3-9C0D-BD986188709B"
			},
			{
				"id": 230,
				"resourceName": "Regions.VIRGIN_ISLANDS_US",
				// USD
				"defaultCurrencyId": "1994DD50-57C4-11E3-9C0D-BD986188709B"
			},
			{
				"id": 233,
				"resourceName": "Regions.WALLISW_AND_FUTUNA_ISLANDS",
				// XPF
				"defaultCurrencyId": "1C5FB0E3-C917-4E07-8684-8847BB73D789"
			},
			{
				"id": 65,
				"resourceName": "Regions.WESTERN_SAHARA",
				"defaultCurrencyId": ""
			},
			{
				"id": 235,
				"resourceName": "Regions.YEMAN",
				// YER
				"defaultCurrencyId": "C642AEF3-F3E8-43B2-9D09-FA1FD6D6093C"
			},
			{
				"id": 239,
				"resourceName": "Regions.ZAMBIA",
				// ZMW
				"defaultCurrencyId": "F380F883-53FE-4119-BD6E-AD6A555B5831"
			},
			{
				"id": 240,
				"resourceName": "Regions.ZIMBABWE",
				//ZAR
				"defaultCurrencyId": "6ec532b6-57c4-11e3-9779-31996188709b"
			}
		];

		var module = {};
		module.private = {};

		//API

		module.browse = function () {
			return data;
		};

		module.read = function (params) {
			if (params['id']) {
				return module.private.getCountryById(params['id'])
			} else if (params['name']) {
				return module.private.getCountryByName(params['name'])
			}
		};

		//utilities

		module.private.getCountryById = function (id) {
			var i, l;

			for (i = 0, l = data.length; i < l; i++) {
				if (data[i].id == id) {
					return data[i];
				}
			}
		};
        module.private.getCountryByName = function getCountryByName(name) {
            var countryDropdown = document.getElementsByName('CountryId')[0];

            if (countryDropdown) {

                for (var i = 0; i < countryDropdown.options.length; i++) {
                    var option = countryDropdown.options[i];
                    if (option.value && option.textContent.trim().toLowerCase() === name.toLowerCase()) {
                        return {
                            id: option.value,
                            name: option.textContent.trim()
                        };
                    }
                }

                // Log warning if country isn't found
                pubsub.publish('loggly.warning', {
                    message: generalUtilities.stringFormat(
                        'unable to find country (require): {0} : {1}',
                        name,
                        generalUtilities.prop(RESAAS, 'Environment.Language')
                    )
                });
            } else {
                // Log warning if country dropdown isn't found
                pubsub.publish('loggly.warning', {
                    message: generalUtilities.stringFormat(
                        'unable to find country dropdown: {0} : {1}',
                        name,
                        window.pageType
                    )
                });
            }

            return undefined;
        };


		return module;
	}
);
